import { FC } from 'react';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import styles from './FormReview.module.scss';
import { reviewService } from '@/services/review.service';

interface IFormReview {
  bookId: number;
  bookAlias?: string;
  isBlogPage?: boolean;
}

const FormReview: FC<IFormReview> = ({ bookId, bookAlias, isBlogPage }) => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      name: '',
      email: '',
      message: '',
      book_id: bookId,
      book_alias: bookAlias,
      status: 'active',
    },
  });

  const [isModerateNoteVisible, setIsModerateNoteVisible] = useState(false);

  return (
    <form
      className={styles.bookReviewForm}
      onSubmit={handleSubmit((data) => {
        if (isBlogPage) {
          reviewService.postBlogReview({ name: data.name, email: data.email, message: data.message, post_id: data.book_id });
        } else {
          reviewService.postReview(data);
        }
        setIsModerateNoteVisible(true);
        setTimeout(() => {
          setIsModerateNoteVisible(false);
        }, 2500);
        reset();
      })}
    >
      <div className={`${styles.rateReviewNotice} ${styles.rateReviewNotice_new}`} data-review-notice>
        Спасибо за оценку! Будем признательны, если Вы оставите комментарий.
      </div>
      <div className={styles.label}>Добавить отзыв</div>

      <div className={styles.bookReviewForm__row}>
        <div className={styles.item}>
          <input {...register('name', { required: true, minLength: 3 })} defaultValue="Ваше имя" placeholder="Имя" className={errors.name ? `${styles.input} ${styles.errorBg}` : `${styles.input}`} />
          {errors.name && <span className={styles.errorMessage}>Никнейм должен быть больше 3 символов</span>}
        </div>

        <div className={styles.item}>
          <input {...register('email')} placeholder="Email" className={`${styles.input} ${styles.recense_email}`} />
        </div>
      </div>

      <div className={styles.item}>
        <textarea {...register('message', { required: true, minLength: 8 })} placeholder="Отзыв" className={errors.message ? `${styles.textarea} ${styles.errorBg}` : `${styles.textarea}`} />
        {errors.message && <span className={styles.errorMessage}>Текст должен быть больше 8 символов</span>}
      </div>

      <div>
        <div className={styles.sendButton}>
          <input type="submit" value="Отправить" className={styles.bookMidBtn} />
        </div>
      </div>
      {isModerateNoteVisible && <div className={styles.bookReviewForm__moderationTxt}>Спасибо! Ваш отзыв был отправлен на модерацию.</div>}
    </form>
  );
};

export default FormReview;
